import { getFormatMessage } from '@/utils/utils'
import { Button, Modal, Progress, Space } from 'antd'
import React, { useEffect, useState } from 'react'
import { BoxUpgradeItem, BoxUpgradeProps } from '../interface'

export const BoxUpgradeModal: React.FC<BoxUpgradeProps> = (
  props: BoxUpgradeProps
) => {
  const [progress, setProgress] = useState<BoxUpgradeItem>()
  const { visible, onOk } = props
  const footer =
    progress?.progress === 100 ? <Button onClick={onOk}>完成</Button> : null
  const formatMessage = getFormatMessage()

  useEffect(() => {
    setProgress(props.item)
  }, [props.item])

  useEffect(() => {
    if (visible === false) {
      setProgress(undefined)
    }
  }, [visible])

  return (
    <Modal
      visible={visible}
      title={'设备升级'}
      footer={footer}
      destroyOnClose={true}
    >
      <div style={{ minHeight: 80 }}>
        <Space>
          <div>
            {progress?.title ||
              formatMessage({
                id: `app.box.upgrade.step.${progress?.step || 0}`
              })}
          </div>
        </Space>
        <Progress percent={progress?.progress} />
      </div>
    </Modal>
  )
}
